import { IoMdLocate } from "react-icons/io";
import { FaCompass } from "react-icons/fa";
import { isMobile, isTablet } from 'react-device-detect';

const Compass = ({
    globalRefs,
    globalState,
    mapbearing
}) => {

    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

    let mobileStatus = isMobile ? "mobile" : "not-mobile";

    if (isTablet) {
        mobileStatus = "tablet";
    }

    return (
        <div className={`compass ${mobileStatus}`}>
            <button
                onClick={() => {
                    if (navigator.geolocation) {
                        polygonCustomLayerRef.current.cameraFlyToNorth();
                    } else {
                        alert('Geolocation is not supported by this browser.');
                    }
                }}
            >
                {isMobile ? <FaCompass style={{ transform: `rotate(${135 + mapbearing}deg)` }} color="#073029" className="compassIcon" size={25} /> :
                    <>
                        <FaCompass style={{ transform: `rotate(${135 + mapbearing}deg)` }} color="#073029" className="compassIcon" size={25} />
                    </>}

            </button>
        </div>
    );
}

export default Compass;
